import React from 'react';
import { Link } from 'react-router-dom';

import { splitLongText } from 'helpers/text';

const SimoSubsList = ({ subs, viewUrl }) => {
  return (
    <div>
      <h3>Simo Subscriptions</h3>
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Device SN</th>
            <th>Status</th>
            <th>Plan</th>
            <th>Agent</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {subs.length > 0 ? (
            subs.map((sub) => {
              return (
                <tr key={sub.id}>
                  <td>{sub.id}</td>
                  <td>{splitLongText(sub.first_name)}</td>
                  <td>{splitLongText(sub.last_name)}</td>
                  <td>{sub.device_sn}</td>
                  <td>{sub.simo_status}</td>
                  <td>{sub.plan && sub.plan.name}</td>
                  <td>{sub.agent_name && sub.agent_name.split(' ')[0]}</td>
                  <td>
                    <Link to={viewUrl(sub.id)}>View</Link>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td>No subscriptions yet</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SimoSubsList;
